import React, { useState, useEffect } from 'react';
import { getTeams, getTeamPersonnel } from '../services/api';
import { Users, UserCheck, Shield } from 'lucide-react';

export default function Teams() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    getTeams().then(res => { setTeams(res.data.teams || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleTeamClick = async (team) => {
    setSelectedTeam(team);
    try {
      const { data } = await getTeamPersonnel(team.id);
      setTeamMembers(data.personnel || []);
    } catch (err) { setTeamMembers([]); }
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>Loading teams...</div>;

  return (
    <div style={{ display: 'flex', height: '100%', overflow: 'hidden' }}>
      <div className="teams-grid" style={{ flex: 1 }}>
        {teams.map(team => (
          <div key={team.id} className="team-card" onClick={() => handleTeamClick(team)}
            style={{ cursor: 'pointer', borderColor: selectedTeam?.id === team.id ? 'var(--accent-blue)' : undefined }}>
            <div className="team-header">
              <div className="team-icon" style={{ background: `${team.category_color || '#3B82F6'}20`, fontSize: 22 }}>
                {team.category_icon || '🛡️'}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{team.name}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{team.category_name || 'General'}</div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 12 }}>
              {team.description}
            </div>
            <div className="team-stats">
              <div className="team-stat">
                <div className="team-stat-value">{team.member_count || 0}</div>
                <div className="team-stat-label">Members</div>
              </div>
              <div className="team-stat">
                <div className="team-stat-value" style={{ color: 'var(--accent-emerald)' }}>{team.available_count || 0}</div>
                <div className="team-stat-label">Available</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedTeam && (
        <div style={{ width: 320, borderLeft: '1px solid var(--border)', overflow: 'auto', background: 'var(--bg-secondary)' }}>
          <div className="panel-header">
            <div className="panel-title">{selectedTeam.name} — Members</div>
          </div>
          <div style={{ padding: 16 }}>
            {teamMembers.length === 0 ? (
              <div style={{ color: 'var(--text-muted)', fontSize: 12, textAlign: 'center', padding: 20 }}>No personnel assigned</div>
            ) : (
              teamMembers.map(p => (
                <div key={p.id} style={{
                  background: 'var(--bg-card)', padding: '12px 14px', borderRadius: 'var(--radius-sm)',
                  border: '1px solid var(--border)', marginBottom: 8
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{p.full_name}</div>
                    <div style={{
                      width: 8, height: 8, borderRadius: '50%',
                      background: p.is_available ? 'var(--accent-emerald)' : 'var(--text-muted)'
                    }} />
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
                    {p.role} • {p.badge_number || 'No badge'} • {p.phone}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
